import styles from "./index.module.css";
import VisualizerBanner from "../visualizer-banner";

export default function Marketplace() {
	return (
		<div className={styles.marketplacePage}>
			<div className={styles.marketplaceContainer}>
				<div className={styles.bannerContainer}>
					<VisualizerBanner />
				</div>
				<iframe
					id="verityMarketplaceIframe"
					allow="microphone; clipboard-write *"
					src={import.meta.env.VITE_MARKETPLACE_URL}
					className={styles.marketplace}
					allowFullScreen
				/>
			</div>
		</div>
	);
}
